<template>
  <div class="landing-cnt row">
    <div class="bg-image"></div>
    <div class="col-12 d-xl-none d-lg-flex main-block-xs"></div>
    <!-- Main text block not logged -->
    <div class="text-block-ctn col-xl-6 col-12 d-flex my-auto">
      <div class="text-ctn my-auto">
        <h1 v-html="$t('openlegal.title')"></h1>
        <h3>{{ title }}</h3>
        <!-- <p>
          {{ $t('text-1')}}
        </p> -->
        <div class="btn-cnt mt-5">
          <base-button class="mt-3" white @click="() => { showSearch = !showSearch }" :textColor="ORANGE_COLOUR">{{ $t('openlegal.find-lawyer')}}</base-button>
          <base-button class="mt-3" @click="$helpers.goToSection('contact-form')" :textColor="GRAY_COLOUR" :borderColor="GRAY_COLOUR" backgroundColor="transparent">{{ $t('openlegal.explain-case') }}</base-button>
        </div>
        <b-row class="mt-5" v-if="showSearch">
          <b-col xs="12" md="10" class="pr-3">
            <base-select v-model="specialist" :options="orderedOptions" valueProp="value" label="label" :placeholder="$t('openlegal.search-ph')"></base-select>
          </b-col>
          <b-col xs="12" md="2">
            <base-button @click="doSearch()" :backgroundColor="ORANGE_COLOUR" :textColor="WHITE_COLOUR" shadow><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/></base-button>
          </b-col>
          <b-col cols="12">
            <a href="#" @click="() => showSearch = false">Volver</a>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="learn-more" @click="$helpers.goToSection('contact-form')" v-if="!$store.getters['session/isLogged'] && !showSearch">
      <span>{{ $t('openlegal.more-info') }}</span>
    </div>
    </div>
</template>

<script>
import BaseSelect from '@/components/base/forms/BaseSelect'
import BaseButton from '@/components/base/buttons/BaseButton'
import { ORANGE_COLOUR, GRAY_COLOUR, WHITE_COLOUR } from '@/constants/colours'

export default {
  components: {
    BaseSelect,
    BaseButton
  },
  data () {
    return {
      ORANGE_COLOUR,
      GRAY_COLOUR,
      WHITE_COLOUR,
      specialist: null,
      showSearch: false,
      // specialistOptions: [
      //   { value: 958, label: 'Familia/Divorcios' },
      //   { value: 959, label: 'Penal/Delitos' },
      //   { value: 960, label: 'Laboral' },
      //   { value: 961, label: 'Bancario' },
      //   { value: 962, label: 'Civil' },
      //   { value: 963, label: 'Herencias' },
      //   { value: 964, label: 'Mercantil/Empresa' },
      //   { value: 965, label: 'Consumo' },
      //   { value: 966, label: 'Vivienda' },
      //   { value: 967, label: 'Impagos/Recobros' },
      //   { value: 968, label: 'Fiscal' },
      //   { value: 969, label: 'Seguros' },
      //   { value: 970, label: 'Administrativo/Multas y sanciones' },
      //   { value: 971, label: 'Contratación' },
      //   { value: 972, label: 'Accidentes tráfico' },
      //   { value: 973, label: 'Comunidades propietarios' },
      //   { value: 974, label: 'Concursal' },
      //   { value: 975, label: 'Ley segunda oportunidad' },
      //   { value: 976, label: 'Inmobiliario' },
      //   { value: 977, label: 'Empresas tecnológicas y emprendimiento' },
      //   { value: 978, label: 'Alquiler' },
      //   { value: 979, label: 'Internacional' },
      //   { value: 980, label: 'Internet' },
      //   { value: null, label: 'Otros' }
      // ]
      specialistOptions: [
        { value: 1692, label: 'Familia/Divorcios' },
        { value: 1693, label: 'Penal/Delitos' },
        { value: 1694, label: 'Laboral' },
        { value: 1695, label: 'Bancario' },
        { value: 1696, label: 'Civil' },
        { value: 1697, label: 'Herencias' },
        { value: 1698, label: 'Mercantil/Empresa' },
        { value: 1699, label: 'Consumo' },
        { value: 1700, label: 'Vivienda' },
        { value: 1701, label: 'Impagos/Recobros' },
        { value: 1702, label: 'Fiscal' },
        { value: 1703, label: 'Seguros' },
        { value: 1704, label: 'Administrativo/Multas y sanciones' },
        { value: 1705, label: 'Contratación' },
        { value: 1706, label: 'Accidentes tráfico' },
        { value: 1707, label: 'Comunidades propietarios' },
        { value: 1708, label: 'Concursal' },
        { value: 1709, label: 'Ley segunda oportunidad' },
        { value: 1710, label: 'Inmobiliario' },
        { value: 1711, label: 'Empresas tecnológicas y emprendimiento' },
        { value: 1712, label: 'Alquiler' },
        { value: 1713, label: 'Internacional' },
        { value: 1714, label: 'Internet' },
        { value: null, label: 'Otros' }
      ]
    }
  },
  methods: {
    doSearch () {
      // return this.$toast.error(this.$t('error-required'))
        if (this.$cookies.get('api_token') == null) {
          this.$router.push({path: '/inicio-sesion', query: {ReturnUrl: `%2Fes%2FHomeCliente%2FIndex%2F#/search?speciality=93&subspeciality=${this.specialist}&location=null&insurance=null`}})
          } else {
            this.$helpers.goToWebApp(`HomeCliente/Index/#/search?speciality=93&subspeciality=${this.specialist}&location=null&insurance=null`)
          }
      }
  },
  computed: {
    orderedOptions () {
      return this.specialistOptions.sort((a, b) => {
        return a.label.localeCompare(b.label)
      })
    }
  },
  props: {
    title: {
      type: String,
      required: false,
      default () {
        return this.$t('openlegal.home-subtitle')
      }
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/views/openlegal/OpenlegalSearchBlock.vue